import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateRegimeSchedulesToLatestVersion = api((regimeId, ids) =>
    mutate(
        gql`
            mutation UpdateSchedulesToLatest($regimeId: String!, $ids: [String!]!) {
                updateRegimeSchedulesToLatestVersion(regimeId: $regimeId, ids: $ids)
            }
        `,
        { regimeId, ids },
        { returns: "updateRegimeSchedulesToLatestVersion" }
    )
)
